// extracted by mini-css-extract-plugin
export var css__bottom = "PageTitle-module--css__bottom--5a7c6";
export var css__description = "PageTitle-module--css__description--e8bcd";
export var css__subtitle = "PageTitle-module--css__subtitle--d43a4";
export var css__title = "PageTitle-module--css__title--44204";
export var css__top = "PageTitle-module--css__top--cc959";
export var css__wrapper = "PageTitle-module--css__wrapper--129df";
export var leftAligned = "PageTitle-module--left-aligned--28853";